import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

interface VisitorDTO {
  id: number;
  name: string;
  email: string;
  nic: string;
  phone: string;
  visitorCompany: string;
  arrivalTime: string;
  departureTime: string;
  visitorRequestId: number;
}

interface ViewVisitorDetailsProps {
  show: boolean;
  onHide: () => void;
  visitor: VisitorDTO | null;
}

const ViewVisitorDetails: React.FC<ViewVisitorDetailsProps> = ({ show, onHide, visitor }) => {
  const formatDate = (iso?: string | null) => {
    if (!iso) return '';
    const d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleString();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Visitor Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {visitor && (
          <Row className="g-4">
            {/* Left Column */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Visitor ID</Form.Label>
                <Form.Control type="text" value={visitor.id} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" value={visitor.name || 'N/A'} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={visitor.email || 'N/A'} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>NIC</Form.Label>
                <Form.Control type="text" value={visitor.nic || 'N/A'} readOnly />
              </Form.Group>
            </Col>
            {/* Right Column */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" value={visitor.phone || 'N/A'} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Company</Form.Label>
                <Form.Control type="text" value={visitor.visitorCompany || 'N/A'} readOnly />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Arrival Time</Form.Label>
                <Form.Control type="text" value={formatDate(visitor.arrivalTime) || 'N/A'} readOnly />
              </Form.Group>
              <Form.Group className="mb-0">
                <Form.Label>Departure Time</Form.Label>
                <Form.Control type="text" value={formatDate(visitor.departureTime) || 'N/A'} readOnly />
              </Form.Group>
            </Col>
          </Row>
        )}
        <div className="d-flex justify-content-end mt-3">
          <Button variant="primary" onClick={onHide}>
            Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewVisitorDetails;